import type { FaireOrderEntity } from "../../entity_types/order";

export const EXG8MG3DD5: FaireOrderEntity = {
  token: "EXG8MG3DD5",
  type: "order",
  orderNumber: "#EXG8MG3DD5",
  status: "unfulfilled",
  totalDollars: 2,
  customerName: "Copper Kettle Mercantile",
  firstOrder: false,
  placedAt: "Dec 1, 2025",
  sourceLabel: "Faire Direct",
  payoutDate: "Pending Ship",
  hasInvoice: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
